import clsx from 'clsx';
import { useTranslate } from 'core/hooks/useTranslate';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { Avatar, Button, FormField, Icon, TextArea } from 'ui';
import Tooltip from 'ui/atoms/Tooltip/Tooltip';

const MessageSenderSimple = ({
  currentUser,
  isFeedbackActivity = false,
  onFeedback = () => {},
  onPublishComment = () => {},
  parentGuid,
  placeholder = 'Comment...',
  showFeedbackOption = false,
}) => {
  const [text, setText] = useState('');
  const [sendEnabled, setSendEnabled] = useState(false);
  const isSending = useRef(false);
  const { t } = useTranslate();

  function onChange(e) {
    setText(e.currentTarget.value);
    setSendEnabled(e.currentTarget.value.length > 1);
  }

  function onSend() {
    if (text.trim() !== '' && !isSending.current) {
      isSending.current = true;
      onPublishComment(parentGuid, text);
      setText('');
      setSendEnabled(false);

      setTimeout(() => {
        isSending.current = false;
      }, 1000);
    }
  }

  const handleKeypress = (e) => {
    if (e.keyCode === 13 && (e.altKey || e.metaKey)) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div className={clsx(`message-sender-simple`)}>
      <div className={`message-sender-simple__main`}>
        <div className="message-sender-simple__avatar">
          <Avatar image={currentUser ? currentUser.avatar : null} />
        </div>
        <div className="message-sender-simple__textarea">
          <FormField isLabelHidden label={t('common:Comments')}>
            <TextArea onKeyDown={handleKeypress} onChange={onChange} placeholder={placeholder} value={text} />
          </FormField>
          <div className={clsx('message-sender-simple__send', { 'message-sender-simple__send--disabled': !sendEnabled })} onClick={sendEnabled ? onSend : null}>
            <Icon name="send" size="lg" />
          </div>
        </div>
        {showFeedbackOption && !isFeedbackActivity && (
          <Tooltip title={t('assigments:Add feedback')} placement={'top'} hasArrow>
            <div className="message-sender-simple__feedback-option">
              <Button ariaLabel={t('assigments:Add feedback')} size="sm" leftIcon="flag" iconSize="md" isIconOnly={true} onClick={onFeedback} />
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

MessageSenderSimple.propTypes = {
  currentUser: PropTypes.object,
  isFeedbackActivity: PropTypes.bool,
  onFeedback: PropTypes.func,
  onPublishComment: PropTypes.func,
  parentGuid: PropTypes.string,
  placeholder: PropTypes.string,
  showFeedbackOption: PropTypes.bool,
};

export default MessageSenderSimple;
